import { connect } from "react-redux";

const GlobalSettingsCheckComponent = ({ settings, check, block, children }) => {
  if (!settings || !check(settings, block)) {
    return null;
  }
  return children;
};

export const GlobalSettingsCheck = connect((state) => ({
  settings: state.appSettings.data,
}))(GlobalSettingsCheckComponent);
